export class GoogleBaseInfo {
    static fromGoogleFile(file: gapi.client.drive.File): GoogleBaseInfo {
        let fileInfo = new GoogleBaseInfo();
        fileInfo.Id = file.id;
        fileInfo.MimeType = file.mimeType;
        fileInfo.Name = file.name;
        fileInfo.Kind = file.kind;
        return fileInfo;
    }

    Id: string;
    MimeType: string;
    Name: string;
    Kind: string;
}